/** Lets the events timeline on the home page be grabbed with the mouse and dragged sideways. */
document.querySelectorAll('.agenda--timeline .events').forEach((track) => {
  let startX = 0;
  let startScroll = 0;
  let dragging = false;
  let moved = false;

  track.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'mouse' || event.button !== 0) return;
    dragging = true;
    moved = false;
    startX = event.clientX;
    startScroll = track.scrollLeft;
  });

  window.addEventListener('pointermove', (event) => {
    if (!dragging) return;
    const distance = event.clientX - startX;
    if (Math.abs(distance) > 5) moved = true;
    if (moved) {
      track.classList.add('is-dragging');
      track.scrollLeft = startScroll - distance;
    }
  });

  window.addEventListener('pointerup', () => {
    dragging = false;
    track.classList.remove('is-dragging');
  });

  // A drag that ends on a link should not follow it.
  track.addEventListener(
    'click',
    (event) => {
      if (moved) {
        event.preventDefault();
        moved = false;
      }
    },
    true
  );
  track.addEventListener('dragstart', (event) => event.preventDefault());
});
